export const TipoAgrupadoras = [
    {
        id: "ALL",
        nombre: "Todos"
    },
    {
        id: "DNI_EMPRESA",
        nombre: "Dni Empresa"
    },
    {
        id: "DNI_REPRESENTANTE_LEGAL",
        nombre: "Dni Representante Legal"
    },
    {
        id: "TELEFONO",
        nombre: "Telefono"
    },
    {
        id: "CORREO",
        nombre: "Correo Electronico" 
    },
    {
        id: "ACT_ECONOMICA",
        nombre: "Actividad Economica" 
    }
];

export const obtenerTipoCliente = (id: string) =>
TipoAgrupadoras.find( tc => tc.id === id );


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/modelo/TipoAgrupadoras.ts